/*
 * File: ErrorFallback.tsx
 * Project: papa-bear
 * -----
 * Last Modified: 14 Feb 2022 11:36:35 am
 * -----
 * Copyright (c) 2022 Elegant Software Solutions All rights reserved.
 */

import { Col, Row } from 'antd';
import React from 'react';

export const ErrorFallbackJSX = ({ error, resetErrorBoundary }: { error: any; resetErrorBoundary: any }): JSX.Element => {
  return (
    <Row justify="center" style={{ marginTop: '20vh' }}>
      <Col>Something went wrong!</Col>
      <Col>Please refresh the app and try again</Col>
      <Col>{error.message}</Col>
    </Row>
  );
};
